import './header-nav.scss'
import jQuery from 'jquery';
import {
  NavFollower,
  scrollToSection,
  stickyContents
} from './nav-helpers';
import { stickyStyled } from '../../assets/js/utilities/stickystyled';


export function NavInit() {

 console.log("nav.js");

 

  var $ = $ || jQuery, // added to see solve jquery issue
    $nav = $('.header__nav');
    // $navLinks = $nav.find('li a'),
    // $container = $("#main");// scroll container for scroll to
    const stickyEl = document.querySelector('.header__nav');

  // stickyContents($nav); // reivew
  // stickyStyled(stickyEl); // reivew

  $("#header .toggle").on({ // was child .header__toggle - but trying to ensure click area is larger
    click: function () {
      $("#header").toggleClass("--toggle-is-on");
      $("body").toggleClass("--nav-is-on");
      $(this).find('.bar').toggleClass("x");
    }
    // , mouseenter: function() {
    //   // $( this ).addClass( "inside" );
    // }, mouseleave: function() {
    //   $( this ).removeClass( "inside" );
    // }
  })


}